// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InsurancePolicies_InsurancePolicyFragment = { __typename?: 'InsurancePolicy', id: string, carrierName?: string | null, kind: Types.InsurancePolicyKind, loanBalanceOutstanding?: CurrencyUSD | null, notes?: string | null, deathBenefitAmount: CurrencyUSD, policyNumber?: string | null, premiumAmount?: CurrencyUSD | null, premiumFrequency?: Types.InsurancePolicyPremiumFrequency | null, initialPremiumDueDate?: Time | null, premiumPaymentSourceKind?: Types.InsurancePolicyPremiumPaymentSourceKind | null, premiumPaymentSourceEntityID?: string | null, premiumPaymentSourceIndividualID?: string | null, premiumPaymentSourceTestamentaryEntityID?: string | null, premiumPaymentTransferTaxKind?: Types.InsurancePolicyPremiumPaymentTransferTaxKind | null, startDate?: Time | null, survivorship: boolean, cashValue?: CurrencyUSD | null, cashValueDate?: Time | null, conversionDate?: Time | null, termDurationYears?: number | null, policyHolders?: Array<{ __typename?: 'ClientProfile', id: string, displayName: string }> | null, premiumPayments: { __typename?: 'InsurancePremiumPaymentConnection', edges?: Array<{ __typename?: 'InsurancePremiumPaymentEdge', node?: { __typename?: 'InsurancePremiumPayment', id: string } | null } | null> | null }, integrationInsurance?: { __typename?: 'IntegrationInsurance', id: string } | null, premiumPaymentGiftingGrantors?: Array<{ __typename?: 'ClientProfile', id: string }> | null, documents?: Array<{ __typename?: 'Document', id: string }> | null };

export type InsurancePolicies_IlitTrustFragment = { __typename?: 'ILITTrust', id: string, crummeyWithdrawalPeriodDays?: number | null, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePolicies_InsurancePersonalAccountFragment = { __typename?: 'InsurancePersonalAccount', id: string, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePolicies_IrrevocableTrustFragment = { __typename?: 'IrrevocableTrust', id: string, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePolicies_RevocableTrustFragment = { __typename?: 'RevocableTrust', id: string, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePolicies_SlatTrustFragment = { __typename?: 'SLATTrust', id: string, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePolicies_LlcFragment = { __typename?: 'LLCBusinessEntity', id: string, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePolicies_GeneralPartnershipFragment = { __typename?: 'GPBusinessEntity', id: string, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePolicies_LimitedPartnershipFragment = { __typename?: 'LPBusinessEntity', id: string, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePolicies_SCorporationFragment = { __typename?: 'SCorpBusinessEntity', id: string, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePolicies_CCorporationFragment = { __typename?: 'CCorpBusinessEntity', id: string, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePolicies_CharitableRemainderTrustFragment = { __typename?: 'CRTTrust', id: string, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePolicies_CharitableLeadTrustFragment = { __typename?: 'CLTTrust', id: string, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePolicies_DonorAdvisedFundFragment = { __typename?: 'DonorAdvisedFund', id: string, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePolicies_PrivateFoundationFragment = { __typename?: 'PrivateFoundation', id: string, policies?: Array<(
    { __typename?: 'InsurancePolicy' }
    & InsurancePolicies_InsurancePolicyFragment
  )> | null };

export type InsurancePoliciesQueryVariables = Types.Exact<{
  nodeId: Types.Scalars['ID']['input'];
}>;


export type InsurancePoliciesQuery = { __typename?: 'Query', node?: { __typename?: 'AISuggestion' } | { __typename?: 'AISuggestionEvidence' } | { __typename?: 'AccessAgeParameter' } | { __typename?: 'AccessParameter' } | { __typename?: 'Account' } | { __typename?: 'ActiveEstateInsightsPage' } | { __typename?: 'Activity' } | { __typename?: 'Address' } | { __typename?: 'Answer' } | { __typename?: 'AnswerEvidence' } | { __typename?: 'AnswerRevision' } | { __typename?: 'Approval' } | { __typename?: 'AssetClass' } | { __typename?: 'AssetGroup' } | { __typename?: 'AssetStatic' } | { __typename?: 'AssetV2' } | { __typename?: 'AssetValuationV2' } | { __typename?: 'AssetValueV2' } | { __typename?: 'AsyncJob' } | { __typename?: 'BalanceSheetBundleConfiguration' } | { __typename?: 'BalanceSheetCategory' } | { __typename?: 'BalanceSheetViewConfiguration' } | { __typename?: 'BeneficiariesBundleConfiguration' } | { __typename?: 'BeneficiariesTemplateBundleConfiguration' } | { __typename?: 'Beneficiary' } | { __typename?: 'BeneficiaryAccessParameter' } | { __typename?: 'BeneficiaryDesignationGroup' } | { __typename?: 'BeneficiaryDistribution' } | { __typename?: 'BeneficiaryDistributionParameter' } | { __typename?: 'BeneficiaryPage' } | { __typename?: 'BeneficiaryPowerOfAppointment' } | { __typename?: 'CCorpBusinessEntity' } | { __typename?: 'CLTProposal' } | { __typename?: 'CLTTrust' } | { __typename?: 'CRTProposal' } | { __typename?: 'CRTTrust' } | { __typename?: 'Capability' } | { __typename?: 'Cashflow' } | { __typename?: 'ClientOrganization' } | { __typename?: 'ClientPresentationV2' } | { __typename?: 'ClientProfile' } | { __typename?: 'ClientProfileRelationship' } | { __typename?: 'Collaborator' } | { __typename?: 'ComparedWaterfall' } | { __typename?: 'CompletedEstateInsightsPage' } | { __typename?: 'ControllingParty' } | { __typename?: 'Conversation' } | { __typename?: 'CoverPageConfiguration' } | { __typename?: 'CustodialPersonalAccount' } | { __typename?: 'DSUEPortability' } | { __typename?: 'DiagramArtifact' } | { __typename?: 'DiagramArtifactPrompt' } | { __typename?: 'DispositionScenario' } | { __typename?: 'DispositiveProvision' } | { __typename?: 'DispositiveProvisionTemplate' } | { __typename?: 'DividerBundleConfiguration' } | { __typename?: 'DividerTemplateBundleConfiguration' } | { __typename?: 'Document' } | { __typename?: 'DocumentQuestion' } | { __typename?: 'DocumentQuestionAnswers' } | { __typename?: 'DocumentSummary' } | { __typename?: 'DocumentSummaryPage' } | { __typename?: 'DocumentSummaryPrompt' } | { __typename?: 'DocumentSummaryPromptTestRun' } | { __typename?: 'DocumentSummaryTemplateBundleConfiguration' } | { __typename?: 'DonorAdvisedFund' } | { __typename?: 'Employee' } | { __typename?: 'EntitiesOverviewBundleConfiguration' } | { __typename?: 'EntitiesOverviewBundleConfigurationEntity' } | { __typename?: 'Entity', id: string, subtype: (
      { __typename?: 'CCorpBusinessEntity', id: string }
      & InsurancePolicies_CCorporationFragment
    ) | (
      { __typename?: 'CLTTrust', id: string }
      & InsurancePolicies_CharitableLeadTrustFragment
    ) | (
      { __typename?: 'CRTTrust', id: string }
      & InsurancePolicies_CharitableRemainderTrustFragment
    ) | { __typename?: 'CustodialPersonalAccount', id: string } | (
      { __typename?: 'DonorAdvisedFund', id: string }
      & InsurancePolicies_DonorAdvisedFundFragment
    ) | (
      { __typename?: 'GPBusinessEntity', id: string }
      & InsurancePolicies_GeneralPartnershipFragment
    ) | { __typename?: 'GRATTrust', id: string } | (
      { __typename?: 'ILITTrust', id: string }
      & InsurancePolicies_IlitTrustFragment
    ) | { __typename?: 'IndividualPersonalAccount', id: string } | (
      { __typename?: 'InsurancePersonalAccount', id: string }
      & InsurancePolicies_InsurancePersonalAccountFragment
    ) | (
      { __typename?: 'IrrevocableTrust', id: string }
      & InsurancePolicies_IrrevocableTrustFragment
    ) | { __typename?: 'JointPersonalAccount', id: string } | (
      { __typename?: 'LLCBusinessEntity', id: string }
      & InsurancePolicies_LlcFragment
    ) | (
      { __typename?: 'LPBusinessEntity', id: string }
      & InsurancePolicies_LimitedPartnershipFragment
    ) | (
      { __typename?: 'PrivateFoundation', id: string }
      & InsurancePolicies_PrivateFoundationFragment
    ) | { __typename?: 'QPRTTrust', id: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string } | { __typename?: 'RetirementPersonalAccount', id: string } | (
      { __typename?: 'RevocableTrust', id: string }
      & InsurancePolicies_RevocableTrustFragment
    ) | (
      { __typename?: 'SCorpBusinessEntity', id: string }
      & InsurancePolicies_SCorporationFragment
    ) | (
      { __typename?: 'SLATTrust', id: string }
      & InsurancePolicies_SlatTrustFragment
    ) | { __typename?: 'SoleProprietorshipBusinessEntity', id: string } } | { __typename?: 'EntityDiagram' } | { __typename?: 'EntityDocumentRelationship' } | { __typename?: 'EntityGraphView' } | { __typename?: 'EntityGraphViewBundleConfiguration' } | { __typename?: 'EntityNotes' } | { __typename?: 'EntityProposal' } | { __typename?: 'EntitySummaryBundleConfiguration' } | { __typename?: 'EntitySummaryTemplateBundleConfiguration' } | { __typename?: 'EntityTask' } | { __typename?: 'EntityTaxInfo' } | { __typename?: 'EstateInsight' } | { __typename?: 'EstateInsightReference' } | { __typename?: 'EstateInsightsBundleConfiguration' } | { __typename?: 'EstateTaxScenario' } | { __typename?: 'EstateWaterfall' } | { __typename?: 'EstateWaterfallHypotheticalStateChange' } | { __typename?: 'EstateWaterfallHypotheticalTransfer' } | { __typename?: 'EstateWaterfallMessageContext' } | { __typename?: 'EstateWaterfallVisualizationConfig' } | { __typename?: 'EstateWaterfallVisualizationFilter' } | { __typename?: 'FamilyTreeBundleConfiguration' } | { __typename?: 'FamilyTreeConfiguration' } | { __typename?: 'FeatureFlag' } | { __typename?: 'FeatureFlagQueryRule' } | { __typename?: 'File' } | { __typename?: 'FilePage' } | { __typename?: 'FileParagraph' } | { __typename?: 'Form' } | { __typename?: 'FormVersion' } | { __typename?: 'GPBusinessEntity' } | { __typename?: 'GRATAnnuityV2' } | { __typename?: 'GRATProposalScenario' } | { __typename?: 'GRATTrust' } | { __typename?: 'GiftingProposal' } | { __typename?: 'GiftingProposalCashFlow' } | { __typename?: 'GiftingProposalGift' } | { __typename?: 'GiftingProposalGiftSender' } | { __typename?: 'GiftingProposalPortfolio' } | { __typename?: 'GiftingProposalScenario' } | { __typename?: 'GraphVisualizationGroup' } | { __typename?: 'GrowthProfile' } | { __typename?: 'GrowthProfileOverride' } | { __typename?: 'Household' } | { __typename?: 'HypotheticalCLT' } | { __typename?: 'HypotheticalCRT' } | { __typename?: 'HypotheticalGRAT' } | { __typename?: 'HypotheticalInsurance' } | { __typename?: 'HypotheticalSaleLoan' } | { __typename?: 'HypotheticalTransferAsset' } | { __typename?: 'HypotheticalTransferFundingSource' } | { __typename?: 'HypotheticalWaterfallDispositiveProvisionTemplate' } | { __typename?: 'ILITCrummeyLetter' } | { __typename?: 'ILITTrust' } | { __typename?: 'Image' } | { __typename?: 'IncomeTaxPaymentConfig' } | { __typename?: 'IndividualPersonalAccount' } | { __typename?: 'InferredField' } | { __typename?: 'InferredFieldEvidence' } | { __typename?: 'InsightsTemplateBundleConfiguration' } | { __typename?: 'InsurancePersonalAccount' } | { __typename?: 'InsurancePolicy' } | { __typename?: 'InsurancePremiumPayment' } | { __typename?: 'IntegrationAssetClass' } | { __typename?: 'IntegrationCashflow' } | { __typename?: 'IntegrationClient' } | { __typename?: 'IntegrationConfiguration' } | { __typename?: 'IntegrationEntity' } | { __typename?: 'IntegrationInsurance' } | { __typename?: 'IntegrationLiability' } | { __typename?: 'IntegrationPerson' } | { __typename?: 'IrrevocableTrust' } | { __typename?: 'JointPersonalAccount' } | { __typename?: 'KGNode' } | { __typename?: 'KGRelationship' } | { __typename?: 'KGRoot' } | { __typename?: 'KGV2Document' } | { __typename?: 'KGV2DocumentChange' } | { __typename?: 'KGV2DocumentModification' } | { __typename?: 'KGV2Graph' } | { __typename?: 'KGV2Node' } | { __typename?: 'KGV2NodeAlias' } | { __typename?: 'KGV2NodeEvidence' } | { __typename?: 'KGV2Statement' } | { __typename?: 'KGV2StatementEvidence' } | { __typename?: 'KGV2StatementSupersession' } | { __typename?: 'KeyPerson' } | { __typename?: 'KeyPersonRole' } | { __typename?: 'LLCBusinessEntity' } | { __typename?: 'LPBusinessEntity' } | { __typename?: 'LiabilitiesBundleConfiguration' } | { __typename?: 'Liability' } | { __typename?: 'LiabilityPayment' } | { __typename?: 'LifeInsuranceBundleConfiguration' } | { __typename?: 'LifetimeExclusionEvent' } | { __typename?: 'LoggedTransfer' } | { __typename?: 'LuminaryOrganization' } | { __typename?: 'LuminaryTenantJIT' } | { __typename?: 'ManagedSFTPConnection' } | { __typename?: 'Memo' } | { __typename?: 'MemoPrompt' } | { __typename?: 'Message' } | { __typename?: 'MissingDocumentOverride' } | { __typename?: 'MissingDocumentsPage' } | { __typename?: 'ModelMapping' } | { __typename?: 'NotificationApp' } | { __typename?: 'NotificationPreference' } | { __typename?: 'OpenaiSdkConfig' } | { __typename?: 'OrganizationApplicationConfiguration' } | { __typename?: 'OrganizationDisclaimerConfiguration' } | { __typename?: 'OwnershipStake' } | { __typename?: 'PlatformDocument' } | { __typename?: 'PlatformFile' } | { __typename?: 'PlatformFilePage' } | { __typename?: 'PlatformFileParagraph' } | { __typename?: 'PresentationApprovalRequest' } | { __typename?: 'PresentationAssetDistributionBundleConfiguration' } | { __typename?: 'PresentationAssetDistributionItemConfiguration' } | { __typename?: 'PresentationAssetDistributionItemDetail' } | { __typename?: 'PresentationBundle' } | { __typename?: 'PresentationBundleCoverPage' } | { __typename?: 'PresentationBusinessOverviewBundleConfiguration' } | { __typename?: 'PresentationBusinessOverviewBusinessConfiguration' } | { __typename?: 'PresentationBusinessOverviewItem' } | { __typename?: 'PresentationCoverPage' } | { __typename?: 'PresentationCoverSlideConfig' } | { __typename?: 'PresentationCustomPage' } | { __typename?: 'PresentationCustomPageBundleConfiguration' } | { __typename?: 'PresentationDiagramPage' } | { __typename?: 'PresentationDocumentsReviewedBundleConfiguration' } | { __typename?: 'PresentationDocumentsReviewedDocument' } | { __typename?: 'PresentationFamilyOverviewBundleConfiguration' } | { __typename?: 'PresentationFamilyOverviewMemberConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveBundleConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveClientConfiguration' } | { __typename?: 'PresentationHealthcareDirectiveItem' } | { __typename?: 'PresentationItemCitation' } | { __typename?: 'PresentationPage' } | { __typename?: 'PresentationPlanningOpportunitiesBundleConfiguration' } | { __typename?: 'PresentationPlanningOpportunitiesItem' } | { __typename?: 'PresentationPowerOfAttorneyBundleConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyClientConfiguration' } | { __typename?: 'PresentationPowerOfAttorneyItem' } | { __typename?: 'PresentationTemplate' } | { __typename?: 'PresentationTemplateBundle' } | { __typename?: 'PresentationTemplateCoverPage' } | { __typename?: 'PresentationTemplateCustomPage' } | { __typename?: 'PresentationTemplateDiagramPage' } | { __typename?: 'PresentationTemplatePage' } | { __typename?: 'PresentationTrustOverviewBundleConfiguration' } | { __typename?: 'PresentationTrustOverviewItem' } | { __typename?: 'PresentationTrustOverviewTrustConfiguration' } | { __typename?: 'PresentationWillBundleConfiguration' } | { __typename?: 'PresentationWillClientConfiguration' } | { __typename?: 'PresentationWillItem' } | { __typename?: 'Principal' } | { __typename?: 'PrivateFoundation' } | { __typename?: 'ProfessionalTeamRole' } | { __typename?: 'Proposal' } | { __typename?: 'ProposalScenario' } | { __typename?: 'QPRTTrust' } | { __typename?: 'QualifiedTuitionPersonalAccount' } | { __typename?: 'ReleaseGroup' } | { __typename?: 'ReminderEmailNotificationRecord' } | { __typename?: 'RetirementPersonalAccount' } | { __typename?: 'RevocableTrust' } | { __typename?: 'Role' } | { __typename?: 'SCorpBusinessEntity' } | { __typename?: 'SLATTrust' } | { __typename?: 'SSOConnection' } | { __typename?: 'SalesforceExportAttempt' } | { __typename?: 'ScheduledDistribution' } | { __typename?: 'SoleProprietorshipBusinessEntity' } | { __typename?: 'SubBrand' } | { __typename?: 'SubBrandDisclaimerConfiguration' } | { __typename?: 'Submission' } | { __typename?: 'TaxDragConfig' } | { __typename?: 'TaxDragOverride' } | { __typename?: 'Team' } | { __typename?: 'Tenant' } | { __typename?: 'TenantApplicationConfiguration' } | { __typename?: 'TenantBranding' } | { __typename?: 'TenantDisclaimerConfiguration' } | { __typename?: 'TenantDocument' } | { __typename?: 'TenantReminderEmailsConfiguration' } | { __typename?: 'TenantSSOConnection' } | { __typename?: 'TenantSecurityConfiguration' } | { __typename?: 'TenantSlideConfig' } | { __typename?: 'TestCMKEncryption' } | { __typename?: 'TestamentaryEntity' } | { __typename?: 'TrustAdvisor' } | { __typename?: 'TrustAdvisorRole' } | { __typename?: 'Trustee' } | { __typename?: 'TrusteeDuty' } | { __typename?: 'User' } | { __typename?: 'UserFeedback' } | { __typename?: 'UserNotificationConfiguration' } | { __typename?: 'WaterfallBundleConfiguration' } | { __typename?: 'WaterfallBundleCoverPage' } | { __typename?: 'WaterfallComparisonBundleConfiguration' } | { __typename?: 'WaterfallComparisonTemplateBundleConfiguration' } | { __typename?: 'WaterfallTemplateBundleConfiguration' } | { __typename?: 'WorkOSOrganization' } | { __typename?: 'WorkOSOrganizationDomain' } | { __typename?: 'WorkflowTracker' } | null };

export const Operations = {
  Query: {
    InsurancePolicies: 'InsurancePolicies' as const
  },
  Fragment: {
    InsurancePolicies_InsurancePolicy: 'InsurancePolicies_InsurancePolicy' as const,
    InsurancePolicies_ILITTrust: 'InsurancePolicies_ILITTrust' as const,
    InsurancePolicies_InsurancePersonalAccount: 'InsurancePolicies_InsurancePersonalAccount' as const,
    InsurancePolicies_IrrevocableTrust: 'InsurancePolicies_IrrevocableTrust' as const,
    InsurancePolicies_RevocableTrust: 'InsurancePolicies_RevocableTrust' as const,
    InsurancePolicies_SLATTrust: 'InsurancePolicies_SLATTrust' as const,
    InsurancePolicies_LLC: 'InsurancePolicies_LLC' as const,
    InsurancePolicies_GeneralPartnership: 'InsurancePolicies_GeneralPartnership' as const,
    InsurancePolicies_LimitedPartnership: 'InsurancePolicies_LimitedPartnership' as const,
    InsurancePolicies_SCorporation: 'InsurancePolicies_SCorporation' as const,
    InsurancePolicies_CCorporation: 'InsurancePolicies_CCorporation' as const,
    InsurancePolicies_CharitableRemainderTrust: 'InsurancePolicies_CharitableRemainderTrust' as const,
    InsurancePolicies_CharitableLeadTrust: 'InsurancePolicies_CharitableLeadTrust' as const,
    InsurancePolicies_DonorAdvisedFund: 'InsurancePolicies_DonorAdvisedFund' as const,
    InsurancePolicies_PrivateFoundation: 'InsurancePolicies_PrivateFoundation' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const InsurancePolicies_InsurancePolicyFragmentDoc = gql`
    fragment InsurancePolicies_InsurancePolicy on InsurancePolicy {
  id
  carrierName
  kind
  loanBalanceOutstanding
  notes
  policyHolders {
    id
    displayName
  }
  deathBenefitAmount
  policyNumber
  premiumAmount
  premiumFrequency
  initialPremiumDueDate
  premiumPayments {
    edges {
      node {
        id
      }
    }
  }
  integrationInsurance {
    id
  }
  premiumPaymentSourceKind
  premiumPaymentSourceEntityID
  premiumPaymentSourceIndividualID
  premiumPaymentSourceTestamentaryEntityID
  premiumPaymentTransferTaxKind
  premiumPaymentGiftingGrantors {
    id
  }
  startDate
  survivorship
  cashValue
  cashValueDate
  conversionDate
  termDurationYears
  documents {
    id
  }
}
    `;
export const InsurancePolicies_IlitTrustFragmentDoc = gql`
    fragment InsurancePolicies_ILITTrust on ILITTrust {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
  crummeyWithdrawalPeriodDays
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePolicies_InsurancePersonalAccountFragmentDoc = gql`
    fragment InsurancePolicies_InsurancePersonalAccount on InsurancePersonalAccount {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePolicies_IrrevocableTrustFragmentDoc = gql`
    fragment InsurancePolicies_IrrevocableTrust on IrrevocableTrust {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePolicies_RevocableTrustFragmentDoc = gql`
    fragment InsurancePolicies_RevocableTrust on RevocableTrust {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePolicies_SlatTrustFragmentDoc = gql`
    fragment InsurancePolicies_SLATTrust on SLATTrust {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePolicies_LlcFragmentDoc = gql`
    fragment InsurancePolicies_LLC on LLCBusinessEntity {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePolicies_GeneralPartnershipFragmentDoc = gql`
    fragment InsurancePolicies_GeneralPartnership on GPBusinessEntity {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePolicies_LimitedPartnershipFragmentDoc = gql`
    fragment InsurancePolicies_LimitedPartnership on LPBusinessEntity {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePolicies_SCorporationFragmentDoc = gql`
    fragment InsurancePolicies_SCorporation on SCorpBusinessEntity {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePolicies_CCorporationFragmentDoc = gql`
    fragment InsurancePolicies_CCorporation on CCorpBusinessEntity {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePolicies_CharitableRemainderTrustFragmentDoc = gql`
    fragment InsurancePolicies_CharitableRemainderTrust on CRTTrust {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePolicies_CharitableLeadTrustFragmentDoc = gql`
    fragment InsurancePolicies_CharitableLeadTrust on CLTTrust {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePolicies_DonorAdvisedFundFragmentDoc = gql`
    fragment InsurancePolicies_DonorAdvisedFund on DonorAdvisedFund {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePolicies_PrivateFoundationFragmentDoc = gql`
    fragment InsurancePolicies_PrivateFoundation on PrivateFoundation {
  id
  policies {
    ...InsurancePolicies_InsurancePolicy
  }
}
    ${InsurancePolicies_InsurancePolicyFragmentDoc}`;
export const InsurancePoliciesDocument = gql`
    query InsurancePolicies($nodeId: ID!) {
  node(id: $nodeId) {
    ... on Entity {
      id
      subtype {
        id
        ...InsurancePolicies_InsurancePersonalAccount
        ...InsurancePolicies_ILITTrust
        ...InsurancePolicies_IrrevocableTrust
        ...InsurancePolicies_RevocableTrust
        ...InsurancePolicies_SLATTrust
        ...InsurancePolicies_LLC
        ...InsurancePolicies_GeneralPartnership
        ...InsurancePolicies_LimitedPartnership
        ...InsurancePolicies_SCorporation
        ...InsurancePolicies_CCorporation
        ...InsurancePolicies_CharitableRemainderTrust
        ...InsurancePolicies_CharitableLeadTrust
        ...InsurancePolicies_DonorAdvisedFund
        ...InsurancePolicies_PrivateFoundation
      }
    }
  }
}
    ${InsurancePolicies_InsurancePersonalAccountFragmentDoc}
${InsurancePolicies_IlitTrustFragmentDoc}
${InsurancePolicies_IrrevocableTrustFragmentDoc}
${InsurancePolicies_RevocableTrustFragmentDoc}
${InsurancePolicies_SlatTrustFragmentDoc}
${InsurancePolicies_LlcFragmentDoc}
${InsurancePolicies_GeneralPartnershipFragmentDoc}
${InsurancePolicies_LimitedPartnershipFragmentDoc}
${InsurancePolicies_SCorporationFragmentDoc}
${InsurancePolicies_CCorporationFragmentDoc}
${InsurancePolicies_CharitableRemainderTrustFragmentDoc}
${InsurancePolicies_CharitableLeadTrustFragmentDoc}
${InsurancePolicies_DonorAdvisedFundFragmentDoc}
${InsurancePolicies_PrivateFoundationFragmentDoc}`;

/**
 * __useInsurancePoliciesQuery__
 *
 * To run a query within a React component, call `useInsurancePoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsurancePoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsurancePoliciesQuery({
 *   variables: {
 *      nodeId: // value for 'nodeId'
 *   },
 * });
 */
export function useInsurancePoliciesQuery(baseOptions: Apollo.QueryHookOptions<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>(InsurancePoliciesDocument, withFetchPolicyContext(options));
      }
export function useInsurancePoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>(InsurancePoliciesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useInsurancePoliciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>(InsurancePoliciesDocument, withFetchPolicyContext(options));
        }
export type InsurancePoliciesQueryHookResult = ReturnType<typeof useInsurancePoliciesQuery>;
export type InsurancePoliciesLazyQueryHookResult = ReturnType<typeof useInsurancePoliciesLazyQuery>;
export type InsurancePoliciesSuspenseQueryHookResult = ReturnType<typeof useInsurancePoliciesSuspenseQuery>;
export type InsurancePoliciesQueryResult = Apollo.QueryResult<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>;